<template>
  <div>
    <head>
      <meta charset="UTF-8">
      <meta http-equiv="X-UA-Compatible" content="IE=edge">
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
      <!-- Title -->
      <!-- Fonts -->
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Gudea:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet">
      <link rel="stylesheet" :href="css">
    </head>
    <div class="container-fluid">
      <div class="row gameplay_pg">
        <div class="iframe_section">
          <iframe :src="frame" frameborder="0"></iframe>
        </div>
      </div>
    </div>
    <component :is="currentModal"></component>
  </div>

</template>


<script>

import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import ResultOfAddOnGame from '@/components/home/game/addongamelanterns/modals/ResultOfAddOnGame';


export default {
  name: 'add-on-game-lantern',
  data() {
    return {
      css: '',
      showAddOnGame: false,
      currentModal: null,
      frame: '',
    };
  },
  created() {
    if (!this.$route.params.fromPreGame) this.$router.push('/home');
    sessionStorage.setItem('time', this.timerForLanternGame);
    if (this.fallingItemsAddOnGameCss === 'lanterns') {
      this.frame = '/static/mini_games/Falling_Lanterns_Game/lanterns_gameplay.html';
      this.css = localStorage.getItem('locale') === ('AR' || 'KU') ?
        '../../../../../static/mini_games/Falling_Lanterns_Game/lanterns_AR.css' :
        '../../../../../static/mini_games/Falling_Lanterns_Game/lanterns.css';
    } else {
      this.frame = '/static/mini_games/Falling_Lanterns_Game/meteorites_gameplay.html';
      this.css = localStorage.getItem('locale') === ('AR' || 'KU') ?
        '../../../../../static/mini_games/Falling_Lanterns_Game/meteorites_AR.css' :
        '../../../../../static/mini_games/Falling_Lanterns_Game/meteorites.css';
    }
    // eslint-disable-next-line
    $('.header-main').hide();
  },
  mounted() {
    // console.log('tets');
    window.addEventListener('message', this.receiveMessage);
  },
  beforeDestroy() {
    this.resetAddOnGameData();
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'resetAddOnGameData',
      'setBonusAddOnGameDataSuccess',
    ]),
    goToAddOnGame() {
      this.showAddOnGame = true;
    },
    receiveMessage(event) {
      // route to net page // modal with these data from index.html (can include if user scored or no)
      if (event.data.isPlayed) {
        window.removeEventListener('message', this.receiveMessage);
        const payload = { success: event.data.ballIn };
        this.setBonusAddOnGameDataSuccess(payload);
        this.currentModal = ResultOfAddOnGame;
        this.showHideModal();
      }
    },
    closeModal() {
      this.getUserLoginDetails().then(() => {
        /* eslint-disable */
        $(".popup_box").fadeOut(200);
        $(".overlay").fadeOut(200);
        $('.modal, .modal-overlay').fadeOut();
        $("body").removeClass("modal-open");
        /* eslint-enable */
        this.$router.push('/home');
      });
    },
    showHideModal() {
      this.$nextTick(() => {
        /* eslint-disable */
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        });
    },
  },
  computed: {
    ...mapState('common', [
      'addOnMode',
      'userDetails',
      'timerForLanternGame',
      'fallingItemsAddOnGameCss',
      'multiOperatorInfo',
    ]),
    ...mapState('game', [
      'homePlayerTotalEarnedPoints',
      'gameID',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addongamelanterns/AddOnGameLantern.vue